import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

interface GraphData {
  D1: number;
  D2: number;
  D3: number;
  D4: number;
  D5: number;
  D6: number;
  D7: number;
}

// const HorizontalBarChart: React.FC<{ graphData: Record<string, number> }> = ({
const HorizontalBarChart: React.FC<{ graphData: GraphData }> = ({
  graphData,
}) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const usersArray = Object.entries(graphData || {})?.map(([key, value]) => ({
      day: key,
      value: value,
    }));
    setData(usersArray);
  }, [graphData]);

  return (
    <div className="bg-[#10151A] p-[30px] rounded-lg w-full mb-[20px]">
      <h2 className="text-gray-200 text-lg mb-2">
        Added Users (in Last Six Days)
      </h2>
      <p className="text-gray-400 text-sm mb-6">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      </p>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 5, right: 0, left: -30, bottom: 5 }}
          >
            <CartesianGrid
              horizontal={false}
              stroke="#444"
              strokeDasharray="3 3"
            />
            <XAxis
              type="number"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#9CA3AF" }}
            />
            <YAxis
              dataKey="day"
              type="category"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#9CA3AF" }}
            />
            <Bar
              dataKey="value"
              fill="#2563EB"
              radius={[0, 4, 4, 0]}
              barSize={20}
            />
            <Tooltip
              cursor={{ fill: "rgba(255, 255, 255, 0.1)" }}
              contentStyle={{
                backgroundColor: "#1F2937",
                borderRadius: "4px",
                border: "none",
                color: "#fff",
              }}
              labelStyle={{ color: "#9CA3AF" }}
              formatter={(value) => [`${value}`, "Users Added"]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HorizontalBarChart;
